import React from 'react';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';

import { logout } from './../store/actions';
import { emptyApp, updateTitle } from 'containers/App/store/actions';
import { emptyAssignments } from 'containers/AssignmentsPage/store/actions';
import { emptyContent } from 'containers/ContentPage/store/actions';
import { emptyGroups } from 'containers/UsersPage/store/groups/actions';
import { emptyUsers } from 'containers/UsersPage/store/users/actions';
import { emptyPinpoints } from 'containers/PinpointsPage/store/actions';
import { emptyReports } from 'containers/ReportsPage/store/actions';
import { emptyAuth } from 'containers/AuthPages/store/actions';

import Content from 'components/Content';
import LoadingSpinner from 'components/LoadingSpinner';

class LogoutPage extends React.Component {
    componentWillMount() {
        this.props.updateTitle('Log Out');
        this.props.logout(() => {
            this.props.emptyApp();
            this.props.emptyAssignments();
            this.props.emptyContent();
            this.props.emptyGroups();
            this.props.emptyUsers();
            this.props.emptyPinpoints();
            this.props.emptyAuth();
            this.props.emptyReports();
            this.props.changeLocation('/login');
            document.body.classList.remove('not-admin');
        })
    }

    render() {
        return (
            <Content>
                <LoadingSpinner />
            </Content>
        );
    }
}

const mapStateToProps = (state) => {
    return {

    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeLocation: (locationString) => dispatch(routerActions.push(locationString)),
        emptyApp: () => dispatch(emptyApp()),
        emptyAssignments: () => dispatch(emptyAssignments()),
        emptyAuth: () => dispatch(emptyAuth()),
        emptyContent: () => dispatch(emptyContent()),
        emptyGroups: () => dispatch(emptyGroups()),
        emptyPinpoints: () => dispatch(emptyPinpoints()),
        emptyReports: () => dispatch(emptyReports()),
        emptyUsers: () => dispatch(emptyUsers()),
        logout: (callback) => dispatch(logout(callback)),
        updateTitle: (title) => dispatch(updateTitle(title))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(LogoutPage);



// WEBPACK FOOTER //
// ./src/containers/AuthPages/LogoutPage/index.js